import ResizableWrapper from '@/components/common/ResizableWrapper';
import { SelectNode } from '@/types/backendNode';
import { List, ListItem, useTheme } from '@mui/material';
import { FC } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import NodeSettingsView from './NodeSettingsView';

type NodeSettingsListProps = {
  nodes: SelectNode[];
  pinNode: (isPinned: boolean, node: SelectNode) => void;
  onClose: (node: SelectNode) => void;
};

const NodeSettingsList: FC<NodeSettingsListProps> = (props) => {
  const theme = useTheme();
  const baseWidth = parseInt(theme.spacing(50), 10);
  const [initialWidth, setInitialWidth] = useLocalStorage('NodeSettingsListWidth', baseWidth);
  const maxWidth = document.body.clientWidth / 2 - parseInt(theme.spacing(2), 10);

  return (
    <ResizableWrapper
      minWidth={baseWidth}
      maxWidth={maxWidth}
      initialWidth={initialWidth}
      handlePosition='left'
      onResize={(newWidth) => setInitialWidth(newWidth)}
    >
      <List
        sx={{
          minWidth: baseWidth,
          color: theme.palette.text.primary,
          bgcolor: theme.palette.background.paper,
          height: '100%',
          overflowY: 'auto'
        }}
      >
        {props.nodes.map((node, index) => {
          return (
            <ListItem key={index}>
              <NodeSettingsView
                node={node}
                pinNode={(isPinned) => props.pinNode(isPinned, node)}
                onClose={() => props.onClose(node)}
              />
            </ListItem>
          );
        })}
      </List>
    </ResizableWrapper>
  );
};

export default NodeSettingsList;
